import { RoleTypes, IsoString, UserCompanyTypes } from 'models';
import { ISurveyCard } from 'modules/admin-panel/models';
import { IPartnerDetails } from 'modules/admin-panel/pages/settings/models/IPartnerDetails';
import { IClientDetails } from 'modules/admin-panel/pages/settings/models/IClientDetails';

export interface ISettingsPayload {
	profilePictureKey: string;
	profilePictureUrl: string;
	firstName: string;
	lastName: string;
	role: RoleTypes;
	phoneNumber: string;
	email: string;
	partner: IPartnerDetails | null;
	client: IClientDetails | null;
	occupation: string;
	surveyData: {
		graphicData: Record<IsoString, number>;
		lastCreated: ISurveyCard[];
		lastSent: ISurveyCard[];
	};
}

export interface IDeleteUserPayload {
	login: string;
	email: string;
	role: RoleTypes;
	companyType: UserCompanyTypes;
	companyId: string;
}

export enum SettingsResultTypes {
	userDetailsUpdated = 'user_details_updated',
	userDeletedByAdmin = 'user_deleted_by_admin',
	userDeletedByThemselves = 'user_deleted_by_themselves',
	passwordChangedByAdmin = 'password_changed_by_admin',
	photoChanged = 'photo_changed',
}

export enum SurveyTrackingResultTypes {
	surveyRoundStopped = 'survey_round_stopped',
	surveyStopped = 'survey_stopped',
	surveyDeleted = 'survey_deleted',
}
